import Dispatcher from '../dispatcher'
import {EventEmitter2} from 'eventemitter2'
import assign from 'object-assign'
import constants from '../constants'
import Actions from '../actions'

// let localGet, localSet
// localGet = require('../utils/localStorage').getItem
// localSet = require('../utils/localStorage').setItem

const Store = assign({}, EventEmitter2.prototype, {
  videoIsOpen: undefined,
  history: undefined,
  story: constants.COLOUR,
  language: `en`,
  lookbookIsOpen: false,
  version: constants.DESKTOP, // constants.MOBILE or constants.DESKTOP
  dispatchToken: Dispatcher.register((payload) => {
    const actionType = payload.type
    const item = payload.item
    switch (actionType) {
    case constants.START_APP:
      const {getLocationLanguage} = require('../utils/i18n')
      Store.language = getLocationLanguage()
      Store.emit(actionType, item)
      break
    case constants.ADD_CHILD:
      Store.emit(actionType, item)
      break
    case constants.REMOVE_CHILD:
      Store.emit(actionType, item)
      break
    case constants.LAUNCH_VIDEO:
      Store.videoIsOpen = true
      Store.emit(actionType, item)
      break
    case constants.CLOSE_VIDEO:
      Store.videoIsOpen = false
      Store.emit(actionType, item)
      break
    case constants.SET_LANGUAGE:
      Store.language = item
      Store.emit(actionType, item)
      break
    case constants.SET_VERSION:
      Store.version = item
      Store.emit(actionType, item)
      break
    case constants.OPEN_LOOKBOOK:
      Store.lookbookIsOpen = true
      setTimeout(Actions.closeMenu)
      Store.emit(actionType, item)
      break
    case constants.CLOSE_LOOKBOOK:
      Store.lookbookIsOpen = false
      Store.emit(actionType, item)
      break
    case constants.UPDATE_STORY:
      Store.story = item
      Store.emit(actionType, item)
      break
    case constants.ROUTE_UPDATED:
      Store.route = item
      Store.history = { title: document.title, url: window.location.pathname }
      Store.emit(actionType, item)
      break
    default:
      Store.emit(actionType, item)
      break
    }
  })
})

export default Store
